// 官网提示说明（非表单）
export default {
  暂无内容: '暂无内容',
  无内容: '暂无内容',
  暂无相关的全球展览: '暂无相关的全球展览',
  暂无相关的全球会议: '暂无相关的全球会议',
  暂无相关的企业: '暂无相关的企业',
  暂无相关的展品: '暂无相关的展品',
  暂无相关的产业头条: '暂无相关的产业头条',
  刷新页面: '刷新页面',
  返回首页: '返回首页',
  '抱歉,您无权访问此页面。': '抱歉,您无权访问此页面。',
  '抱歉,您访问的页面不存在。': '抱歉,您访问的页面不存在。',
  '服务器开小差啦，请再次刷新或检查网络': '服务器开小差啦，请再次刷新或检查网络',
}
